module.exports = __webpack_public_path__ + "img/grass1.724a9d84.jpg";